import React, {Component} from 'react';
import classnames from 'classnames';

import './styles.css';

export default class Paginator extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPageSize: 20,
      currentPage: 0
    }
  }

  componentDidMount() {
    // this.changePage();
  }

  componentWillReceiveProps(nextProps) {
    this.setState({data: nextProps.data}, () => {
      if(this.state.currentPage === 0){
        this.toNextPage();
      }
    });
  }

  getTotalPageCount = () => {
    if(this.state.currentPageSize !== -1) {
      return Math.ceil(this.props.data.length/this.state.currentPageSize);
    }else {
      return 1;
    }
  }

  onPageSizeChange = (event) => {
    const currentPageSize = event.target.value;
    if(currentPageSize === "-1") {
      this.setState({currentPageSize: this.props.data.length, currentPage: 1}, () => {
        this.changePage();
      });
    }else {
      this.setState({currentPageSize, currentPage: 1}, () => {
        this.changePage();
      });
    }
  }

  toPreviousPage = () => {
    this.setState(prevState => {
      return {currentPage: prevState.currentPage - 1}
    }, () => {
      this.changePage();
    });
  }

  toNextPage = () => {
    this.setState(prevState => {
      return {currentPage: prevState.currentPage + 1}
    }, () => {
      this.changePage();
    });
  }

  changePage = () => {
    if(this.state.currentPageSize === this.props.data.length) {
      this.props.onPageSizeChange(this.state.data);
    }else {
      const data =  [...this.state.data];
      const startIndex = (this.state.currentPageSize * (this.state.currentPage -1)) + 1;
      const endIndex = this.state.currentPageSize * this.state.currentPage;
      this.props.onPageSizeChange(data.slice(startIndex-1, endIndex));
    }
  }

  render() {
    return (
      <div className="gdocs-paginator">
      <div className="gdocs-paginator-container">
      <span className="paginator-text">Show</span>
      <span className="paginator-btn-group">
      {this.props.pageSizes.map((pageSize, index) => <Button key={index} value={pageSize} currentPageSize={this.state.currentPageSize} onclick={this.onPageSizeChange}>{pageSize}</Button>)}
      <Button value="-1" currentPageSize={this.state.currentPageSize} onclick={this.onPageSizeChange}>All</Button>
      </span>
      <span className="paginator-text">of {this.props.data.length} cases</span>
      <span className="pull-right">
      <span className="paginator-text">Page {this.state.currentPage} of {this.getTotalPageCount()}</span>
      <span className="paginator-btn-group no-right-margin">
      <button className="paginator-btn" disabled={this.state.currentPage === 1} onClick={this.toPreviousPage}><i className="icon icon-chevron-left"></i></button>
      <button className="paginator-btn" disabled={this.state.currentPage === this.getTotalPageCount()} onClick={this.toNextPage}><i className="icon icon-chevron-right"></i></button>
      </span>
      </span>
      </div>
      <div className="paginator-hr"></div>
      </div>
    )
  }
}



const Button = (props) => {
  const active = classnames({ "active": props.value === props.currentPageSize});
  return (
    <button className={`paginator-btn ${active}`} value={props.value} onClick={props.onclick}>{props.children}</button>
  )
}



// WEBPACK FOOTER //
// ./src/components/common/Table/Paginator/index.js